/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "1.6.0",
  "gitBuildTime": "2026-05-15T13:03:20.880Z",
  "gitBuildVersion": "1.6.0",
  "gitCommitId": "6aec978",
  "gitCommitIdFull": "6aec9785f576e65185b22f907b6f76b68d44aecb",
  "gitCommitTime": "2026-05-15T00:25:55.000Z",
  "version": "1.6.0-2026-05-15T00:25:55.000Z-(6aec978)"
};
